'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAskForEmailMessage = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reselect = require('reselect');

var _getWelcomeMessage = require('./getWelcomeMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAskForEmailMessage = exports.getAskForEmailMessage = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, function () {
  var welcomeMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return welcomeMessage.askForEmailMessage || _I18n2.default.text('conversationsUI.default.askForEmailMessage');
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getAskForEmailMessage.js
// module id = 566
// module chunks = 2 3